// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"b4c4ee6d","473":"81bac0cb","488":"180d0757","492":"9c6dbf7b","556":"a079bfc6","586":"f88aa926","811":"d1b722c2","852":"e70c8095","854":"e5b0ecd5"}[chunkId] + ".chunk.js";
};